import React from "react";
import {createRoot} from "react-dom/client";
import {ErrorBoundary} from "@components/ui/error-boundary";
import {EntryApp} from "src/pages/entry/EntryApp";

const container = document.getElementById("contact-box");
const root = createRoot(container);

root.render(
    <ErrorBoundary>
        <EntryApp/>
    </ErrorBoundary>
);





